export default {"src":"/_next/static/media/undo.7871c6ac.svg","height":10,"width":18,"blurWidth":0,"blurHeight":0};